export enum apiUrl {
    GET_ANALYTICS = '/v1/business-analytics/',
    GET_TOP_SEARCH = '/v1/business-top-searches/',
    GET_TOP_PREFERENCES = '/v1/business-event-preferences/',
    GET_AVERAGE_RATING = '/v1/business-avg-rating/',
}
